module.exports = __webpack_public_path__ + "static/media/2ebac75c.jpeg";